import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(true);
  return <AnimatePresence data-id="element-238">
      {isVisible && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="bg-[#C9A84C] text-[#0F2340] relative z-50 overflow-hidden" data-id="element-239">
          <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-center relative" data-id="element-240">
            <p className="text-sm md:text-base font-bold text-center pr-8 animate-[pulse_2s_ease-in-out_infinite]" data-id="element-241">
              🔥 50% DESCUENTO + 4 BONOS DE REGALO — Solo por tiempo limitado
            </p>
            <button onClick={() => setIsVisible(false)} className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-black/10 rounded-full transition-colors" aria-label="Cerrar alerta" data-id="element-242">
              <XIcon className="w-5 h-5" data-id="element-243" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}